import type { ReduxState } from './druid/types/internal/ReduxState';

export default ({ shouldSpeakIncomingActivity }: ReduxState): boolean => shouldSpeakIncomingActivity;
